import React from "react"

const line = () => {
    return (
        <div className="line"></div>
    )
}

export default line
